import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesEditItemRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-edit-item',
	path: '/secure/admin/EditFieldScreenSchemeItem([!%]?[\\w]*).jspa',
};
